module.exports = "https://cdn.realtymogul.com/static/media/icon_building_star.284d8c2c.svg";